module.exports = __webpack_public_path__ + "img/torus-auth-password.16c6455d.svg";